import { createContext, useContext } from 'react';

const SpotifyImportContext = createContext();

SpotifyImportContext.displayName = 'SpotifyImportContext';

const useSpotifyImport = () => useContext(SpotifyImportContext);

export { SpotifyImportContext, useSpotifyImport };
